import { render, staticRenderFns } from "./SearcheBugs.vue?vue&type=template&id=37f296d4&"
import script from "./SearcheBugs.vue?vue&type=script&lang=js&"
export * from "./SearcheBugs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports